// Simple global event bus for cross-component notifications
// Usage:
//   import EventBus from "./EventBus";
//   EventBus.dispatch("billing:dataChanged", { type: "service" });
//   const off = EventBus.on("billing:dataChanged", (e) => { ... });
//   off(); // unsubscribe

class SimpleEventBus {
  constructor() {
    this.target = new EventTarget();
  }

  on(eventName, callback) {
    const handler = (event) => callback(event);
    this.target.addEventListener(eventName, handler);
    return () => this.target.removeEventListener(eventName, handler);
  }

  dispatch(eventName, detail) {
    const evt = new CustomEvent(eventName, { detail });
    this.target.dispatchEvent(evt);
  }
}

const EventBus = new SimpleEventBus();
export default EventBus;






